import { render, staticRenderFns } from "./manageAutomation.vue?vue&type=template&id=478a4c98&scoped=true"
import script from "./manageAutomation.vue?vue&type=script&lang=js"
export * from "./manageAutomation.vue?vue&type=script&lang=js"
import style0 from "./manageAutomation.vue?vue&type=style&index=0&id=478a4c98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478a4c98",
  null
  
)

export default component.exports